export default __webpack_public_path__ + "static/it-d71a027e6909c835b677875118e293ea.svg";